import DDados from '../address.exterior.ddados';
import api from '../service/address.service';
import DDadosItem from '@common/components/ddados/ddados.item';
import React, { Fragment, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import focusHelper from '@common/helpers/focus.helper';
import _ from 'lodash';

function AddressExterior(props) {
  const { Campos } = DDados;
  const { name, prefix, onFocusCep, onBlur, numeroObrigatorio } = props;

  const isView = prefix == 'V';

  const [Endereco, setEndereco] = useState({});

  getDerivedStateFromProps(props);

  function getDerivedStateFromProps(props) {
    let [prevState, setPrevState] = useState(null);

    if (props.state !== prevState) {
      setPrevState(props.state);
      setEndereco({
        ...props.state,
        UF: props.state?.Uf || props.state?.UF,
      });
    }
  }

  async function handleBlurCodigoPostal(value) {
    // Somente retorna caso Código Postal não tenha alterado
    if (Endereco.Cep == value) return;

    const codigoPostal = value?.replace(/[^0-9A-Z]+/g, '');
    const maskClean = Endereco.Mask?.replace(/[#a\*]+/g, '');

    // Caso o não pais não possua máscara de Código Postal somente o salva no state e retorna
    if (!Endereco.Mask) {
      setEndereco({ ...Endereco, Cep: value });
      return;
    }

    // Caso Código Postal não esteja preenchido, limpa os campos e os desabilita
    if (!codigoPostal || codigoPostal === maskClean) {
      setEndereco({
        ...Endereco,
        Cep: undefined,
        Logradouro: undefined,
        Numero: undefined,
        Complemento: undefined,
        Cidade: undefined,
        Bairro: undefined,
        UF: undefined,
      });
      changeDisableAccessoryFields(true);
      return;
    }

    // Verifica o Código Postal informado em relação a máscara do país para realizar a consulta
    const maskLength = Endereco.Mask?.replace(/[^#a\*0-9A-Z]+/g, '').length || 0;
    if (codigoPostal && codigoPostal.length == maskLength && Endereco.Pais && value != Endereco.Mask) {
      try {
        const result = await api.getByCodigoPostal({ codigoPostal: codigoPostal, pais: Endereco.Pais.NomePais });
        setEndereco({ ...Endereco, ...result.data, Pais: Endereco.Pais, Cep: value });
      } catch (error) {
        setEndereco({ ...Endereco, Cep: value });
      }

      changeDisableAccessoryFields(false);
    } else setEndereco({ ...Endereco, Cep: value });
  }

  function handleChangePais(value) {

    if (Endereco.Pais == value) return;

    if (value) {
      // Caso não possua máscara habilita o Código Postal como opcional
      if (!value.Mascara) {
        DDados.Campos.Cep.Obrigatorio = false;
        DDados.Campos.Cep.Desabilitado = false;
        changeDisableAccessoryFields(false);

        setEndereco({ Cep: undefined, Pais: value, Mask: undefined });
      } else {
        if (!value.Mascara.match(/[#*a]+/g)) {
          DDados.Campos.Cep.Desabilitado = true;
          changeDisableAccessoryFields(false);
        } else {
          DDados.Campos.Cep.Desabilitado = false;
          changeDisableAccessoryFields(true);
        }

        setEndereco({
          Cep: value.Mascara.match(/[#*a]+/g) ? undefined : value.Mascara,
          Pais: value,
          Mask: value.Mascara,
        });
      }
    } else {
      DDados.Campos.Cep.Desabilitado = true;
      changeDisableAccessoryFields(true);
      setEndereco({});
    }
  }

  function handleChangeCidade(value) {
    if (Endereco.Cidade == value) return;

    if (value) {
      setEndereco({ ...Endereco, UF: value.Uf || Endereco.UF, Cidade: value.Cidade || value });
    } else {
      setEndereco({ ...Endereco, Cidade: undefined });
    }
  }

  function handleBlurUF(value) {
    if (Endereco.UF == value) return;

    if (value) {
      setEndereco({ ...Endereco, UF: value });
    } else {
      setEndereco({ ...Endereco, UF: undefined });
    }
  }

  function handleChangeBairro(value) {
    if (Endereco.Bairro == value) return;

    if (value) {
      setEndereco({
        ...Endereco,
        UF: value.UF || Endereco.UF,
        Cidade: value.Cidade || Endereco.Cidade,
        Bairro: value.Bairro || value,
      });
    } else {
      setEndereco({ ...Endereco, UF: undefined, Cidade: undefined, Bairro: undefined });
    }
  }

  function handleBlurComplemento(value) {
    if (Endereco.Complemento == value) return;

    if (value) {
      setEndereco({ ...Endereco, Complemento: value });
    } else {
      setEndereco({ ...Endereco, Complemento: undefined });
    }
  }

  function handleBlurNumero(value) {
    if (Endereco.Numero == value) return;

    if (value) {
      setEndereco({ ...Endereco, Numero: value });
    } else {
      setEndereco({ ...Endereco, Numero: undefined });
    }
  }

  function handleChangeLogradouro(value) {
    if (Endereco.Logradouro == value) return;

    if (value) {
      setEndereco({
        ...Endereco,
        Cep: value.CEP || Endereco.Cep,
        UF: value.UF || Endereco.UF,
        Cidade: value.Cidade || Endereco.Cidade,
        Logradouro: value.Logradouro || value.Logradouro || value,
        Tipo: value.Tipo || Endereco.Tipo,
        Bairro: value.Bairro || Endereco.Bairro,
      });
    } else {
      setEndereco({ ...Endereco, Logradouro: undefined });
    }
  }

  function isRequiredField(field) {
    if (prefix == 'V') return false;

    return DDados.Campos[field].Obrigatorio;
  }

  function isDisabledField(field) {
    const { Cep } = Endereco;

    // desabilita campos quando CEP for valido
    if (
      !!Cep &&
      (field === 'Numero' ||
        field === 'Complemento' ||
        field === 'Bairro' ||
        field === 'Pais' ||
        field === 'Logradouro' ||
        field === 'Cidade' ||
        field === 'UF')
    )
      return false;

    return DDados.Campos[field].Desabilitado;
  }

  function changeDisableAccessoryFields(disable) {
    DDados.Campos.Logradouro.Desabilitado = disable;
    DDados.Campos.Numero.Desabilitado = disable;
    DDados.Campos.Complemento.Desabilitado = disable;
    DDados.Campos.Cidade.Desabilitado = disable;
    DDados.Campos.Bairro.Desabilitado = disable;
    DDados.Campos.UF.Desabilitado = disable;
  }

  return (
    <Fragment>
      <Row>
        <Col sm="2">
          <DDadosItem
            {...Campos.Pais}
            name={name + '.Pais'}
            state={Endereco}
            stateName="Pais"
            service={api.suggestionPais}
            parameters={{
              somenteExterior: true,
            }}
            mapItem={(item) => ({ ...item, Exibicao:  `${item.Id} - ${item.NomePais}` })}
            isView={isView}
            onChange={handleChangePais}
            Desabilitado={false}
          />
        </Col>
        <Col sm="2">
          <DDadosItem
            {...Campos.Cep}
            name={name + '.Cep'}
            Mascara="DYNAMIC"
            noValidate={true}
            dynamicMask={Endereco.Mask || ''}
            state={Endereco}
            stateName="Cep"
            isView={isView}
            onBlur={handleBlurCodigoPostal}
          />
        </Col>
        <Col sm="8">
          <DDadosItem
            {...Campos.Logradouro}
            name={name + '.Logradouro'}
            stateName="Logradouro"
            service={api.suggestionLogradouro}
            parameters={{
              cep: Endereco?.Cep,
              uf: Endereco?.Uf,
              cidade: Endereco?.Cidade,
              bairro: Endereco?.Bairro,
              exterior: true
            }}
            mapItem={(item) => ({ ...item, Exibicao: item.Logradouro })}
            state={Endereco}
            editavel={true}
            isView={isView}
            onChange={handleChangeLogradouro}
            Desabilitado={isDisabledField('Logradouro')}
            Obrigatorio={isRequiredField('Logradouro')}
          />
        </Col>
      </Row>
      <Row>
        <Col sm="2">
          <DDadosItem
            name={name + '.Numero'}
            stateName="Numero"
            {...Campos.Numero}
            state={Endereco}
            isView={isView}
            onBlur={handleBlurNumero}
            Desabilitado={isDisabledField('Numero')}
            Obrigatorio={numeroObrigatorio ?? isRequiredField('Numero')}
          />
        </Col>
        <Col sm="10">
          <DDadosItem
            name={name + '.Complemento'}
            stateName="Complemento"
            {...(props.Campos?.Complemento || Campos.Complemento)}
            state={Endereco}
            isView={isView}
            onBlur={handleBlurComplemento}
            Desabilitado={isDisabledField('Complemento')}
            Obrigatorio={isRequiredField('Complemento')}
          />
        </Col>
      </Row>
      <Row>
        <Col sm="4">
          <DDadosItem
            {...Campos.Bairro}
            name={name + '.Bairro'}
            stateName="Bairro"
            service={api.suggestionBairro}
            parameters={{
              cep: Endereco?.Cep,
              uf: Endereco?.UF,
              cidade: Endereco?.Cidade,
              logradouro: Endereco?.Logradouro,
              exterior: true
            }}
            mapItem={(item) => ({ ...item, Exibicao: item.Bairro })}
            state={Endereco}
            editavel={true}
            isView={isView}
            onChange={handleChangeBairro}
            Desabilitado={isDisabledField('Bairro')}
            Obrigatorio={isRequiredField('Bairro')}
          />
        </Col>
        <Col sm="3">
          <DDadosItem
            {...Campos.Cidade}
            name={name + '.Cidade'}
            stateName="Cidade"
            service={api.suggestionCidade}
            parameters={{
              cep: Endereco?.CEP,
              uf: Endereco?.UF,
              exterior: true
            }}
            mapItem={(item) => ({ ...item, Exibicao: item.Uf ? `${item.Cidade} - ${item.Uf}` : item.Cidade })}
            state={Endereco}
            editavel={true}
            isView={isView}
            onChange={handleChangeCidade}
            Obrigatorio={isRequiredField('Cidade')}
            Desabilitado={isDisabledField('Cidade')}
          />
        </Col>
        <Col sm="3">
          <DDadosItem
            {...Campos.UF}
            name={name + '.UF'}
            state={Endereco}
            stateName="UF"
            isView={isView}
            onBlur={handleBlurUF}
            Obrigatorio={isRequiredField('UF')}
            Desabilitado={isDisabledField('UF')}
          />
        </Col>
      </Row>
    </Fragment>
  );
}

export default AddressExterior;
